<template>
  <div class="col-md-7 login-left d-none d-md-block">
    <div
      class="h-full d-flex flex-column align-items-center justify-content-between"
    >
      <img class="login-logo pointer" src="../../assets/img/logo.png" />
      <div>
        <img class="login-pc" src="../../assets/img/login-pc.svg" />
      </div>
      <div class="under-pc-text">Marco dental blog CMS by Arsa</div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LayoutLeftAuth"
};
</script>
<style scoped>
.login-left {
  background: rgb(41, 98, 255);
  background: radial-gradient(circle, #018b91 10%, #006266 60%, #014042 100%);
  height: 100vh;
  color: white;
  box-shadow: 4px 0px 6px rgba(0, 0, 0, 0.25);
}
.login-logo {
  width: 180px;
  margin-top: 60px;
}
.login-pc {
  height: 196px;
  width: 219px;
  margin-bottom: 66px;
}
.under-pc-text {
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
}
.foreman-rectangle {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 20px;
  bottom: 40px;
  width: 100%;
  margin-bottom: 40px;
}
.foreman {
  font-size: 16px;
  line-height: 24px;
}
.foreman-description-txt {
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.0875px;
}
.foreman-arrow a {
  color: white;
}
a {
  text-decoration: none;
  color: #fff;
}
</style>
